<template>
    <div class="cart2">
        <PortfolioSteps :current-step="2"></PortfolioSteps>
        <v-card-title>
            Datos para tu comprobante de pago
        </v-card-title>
        <v-card-subtitle>Puedes elegir si emites el comprobante a tu nombre o al de un tercero.</v-card-subtitle>
        <v-divider></v-divider>

        <div class="d-flex align-center pt-2">
            <v-card-subtitle class="py-2">
                ¿Deseas generar el/los comprobante(s) de pago a tu nombre?
            </v-card-subtitle>
            <v-switch
                v-model="cart.facturar_todo"
                inset
                :label="cart.facturar_todo ? 'Si' : 'No'"
                class="mt-0"
                @change="uniqueReceiptCheckChange"
            ></v-switch>
        </div>

        <div v-if="cart.facturar_todo">
            <v-card-title class="pt-2 text-h6">
                Captura o selecciona los datos para generar tu comprobante de pago
            </v-card-title>
            <v-card   v-if="contactsDataForAll.fiscalContact != null">
                <v-card-title class="pt-0">{{ contactsDataForAll.fiscalContact.nombre_contacto }}</v-card-title>
                <v-card-subtitle>{{contactsDataForAll.fiscalContact.rfc}}</v-card-subtitle>
                <v-card-subtitle class="font-weight-bold pt-0 pb-0">Dirección:</v-card-subtitle>
                <v-card-subtitle class="pt-0 pb-0">{{contactsDataForAll.fiscalContact.direccion_completa}}</v-card-subtitle>
            </v-card>
            <v-card-text>
                <v-btn
                    :color="pantoneBlack" class="white--text px-8"
                    @click="selectFiscalContact('receipt')"
                    tile
                >
                    Seleccionar
                </v-btn>
            </v-card-text>
            <v-divider></v-divider>

            <!--<div class="d-flex align-center pt-2" v-if="canInvoiceForAll()">
                <v-card-subtitle class="py-2">¿Requiere factura?</v-card-subtitle>
                <v-switch
                    v-model="requireInvoiceForAll"
                    inset
                    :label="requireInvoiceForAll ? 'Si' : 'No'"
                    class="mt-0"
                ></v-switch>
            </div>-->

            <div v-if="requireInvoiceForAll">
                <div class="d-flex align-center">
                    <v-card-subtitle>
                        ¿Desea utilizar los mismos datos del recibo para generar la factura?
                    </v-card-subtitle>
                    <v-switch
                        v-model="sameContactForInvoiceForAll"
                        inset
                        :label="sameContactForInvoiceForAll ? 'Si' : 'No'"
                        class="mt-0"
                        @change="setReceiptInfoForInvoiceAll()"
                    ></v-switch>
                </div>
                <v-card-title class="pt-0 text-h6">
                    Captura o selecciona los datos para generar tu recibo de pago
                </v-card-title>
                <v-card outlined v-if="contactsDataForAll.fiscalContactInvoice != null">
                    <v-card-title class="pt-0">{{ contactsDataForAll.fiscalContactInvoice.nombre_contacto }}</v-card-title>
                    <v-card-subtitle>{{contactsDataForAll.fiscalContactInvoice.rfc}}</v-card-subtitle>
                    <v-card-subtitle class="font-weight-bold pt-0 pb-0">Dirección:</v-card-subtitle>
                    <v-card-subtitle class="pt-0 pb-0">{{contactsDataForAll.fiscalContactInvoice.direccion_completa}}</v-card-subtitle>
                </v-card>
                <v-card-text>
                    <v-btn
                        :color="pantoneBlack" class="white--text px-8"
                        @click="selectFiscalContact('invoice')"
                        tile    
                    >
                        Seleccionar
                    </v-btn>
                </v-card-text>
            </div>
        </div>
        <v-divider v-else class="mt-4 mb-6"></v-divider>

        <template v-if="!cart.facturar_todo && cart2DataDetails != null">
            <v-card
                v-for="procedure in cart2DataDetails.tramites_carrito"
                :key="procedure.id"
                class="my-2"
            >
                <v-card-title>{{ procedure.nombre_tramite}}</v-card-title>
                <v-card-subtitle class="pb-0">{{ procedure.descripcion }}</v-card-subtitle>
                <v-card-title class="pt-1 pb-5">{{ procedure.precio| currency }}</v-card-title>
                <v-card-subtitle class="">Captura o selecciona los datos para generar tu recibo de pago</v-card-subtitle>

                <v-card class="mx-2" outlined v-if="contactsData.fiscalContacts[procedure.id] != null">
                    <v-card-title class="pt-0">{{ contactsData.fiscalContacts[procedure.id].nombre_contacto }}</v-card-title>
                    <v-card-subtitle>{{contactsData.fiscalContacts[procedure.id].rfc}}</v-card-subtitle>
                    <v-card-subtitle class="font-weight-bold pt-0 pb-0">Dirección:</v-card-subtitle>
                    <v-card-subtitle class="pt-0 pb-0">{{contactsData.fiscalContacts[procedure.id].direccion_completa}}</v-card-subtitle>
                </v-card>

                <v-card-text>
                    <v-btn :color="pantoneBlack" class="white--text px-8" @click="selectFiscalContact('receipt', procedure)" tile>
                        Seleccionar
                    </v-btn>
                </v-card-text>
                <v-divider></v-divider>

                <div
                    class="d-flex align-center pt-2"
                    v-if="procedure.facturable == 1 && contactsData.fiscalContacts[procedure.id] != null"
                >
                    <v-card-subtitle class="py-2">¿Requiere factura?</v-card-subtitle>
                    <v-switch
                        v-model="requireInvoice[procedure.id]"
                        inset
                        :label="requireInvoice[procedure.id] ? 'Si' : 'No'"
                        class="mt-0"
                    ></v-switch>
                </div>

                <div v-if="requireInvoice[procedure.id] !== undefined && requireInvoice[procedure.id]">
                    <div class="d-flex align-center">
                        <v-card-subtitle>
                            ¿Desea utilizar los mismos datos del recibo para generar la factura?
                        </v-card-subtitle>
                        <v-switch
                            v-model="sameContactForInvoice[procedure.id]"
                            inset
                            :label="sameContactForInvoice[procedure.id] ? 'Si' : 'No'"
                            class="mt-0"
                            @change="setReceiptInfoForInvoice(procedure.id)"
                        ></v-switch>
                    </div>
                    <v-card-title class="pt-0 text-h6">
                        Captura o selecciona los datos para generar tu recibo de pago
                    </v-card-title>
                    <v-card class="mx-2" outlined v-if="contactsData.fiscalContactInvoices[procedure.id]">
                        <v-card-title class="pt-0">
                            {{ contactsData.fiscalContactInvoices[procedure.id].nombre_contacto }}
                        </v-card-title>
                        <v-card-subtitle>
                            {{contactsData.fiscalContactInvoices[procedure.id].rfc}}
                        </v-card-subtitle>
                        <v-card-subtitle class="font-weight-bold pt-0 pb-0">Dirección:</v-card-subtitle>
                        <v-card-subtitle class="pt-0 pb-0">
                            {{contactsData.fiscalContactInvoices[procedure.id].direccion_completa}}
                        </v-card-subtitle>
                    </v-card>
                    <v-card-text>
                        <v-btn
                            :color="pantoneBlack" class="px-8 white--text"
                            @click="selectFiscalContact('invoice', procedure)"
                            tile
                        >
                            Seleccionar
                        </v-btn>
                    </v-card-text>
                </div>
            </v-card>
        </template>

        <FiscalContact
            v-if="showFiscalContactModal"
            :show-modal="showFiscalContactModal"
            :close-modal="closeFiscalContactModal"
            :selected-fiscal-contact="onSelectedFiscalContact"
            :procedure-contact-default="procedureContactDefault"
        />

        <ErrorModal
            :show-modal="showErrorModal"
            :message-code="errorCodeModal"
            :close-error-modal="closeErrorModal"
        />

    </div>
</template>

<script>
import PortfolioSteps from "../PortofolioSteps";
import FiscalContact from "./FiscalContact";
import ErrorModal from "./ErrorModal";

export default {
    name: "ReceipsPayment",
    props: ['showCart2Details', 'cart2DataDetails', 'procedures', 'setCartFinalData', 'defaultFiscalContact'],
    components: {
        PortfolioSteps, FiscalContact, ErrorModal
    },
    data(){
        return {
            showErrorModal: false,
            errorCodeModal: 0,

            requireInvoiceForAll: false,
            sameContactForInvoiceForAll: false,

            //Objecto a enviar al WS para el Carrito 3
            //Para uando se selecciona Recibo con Datos unicos
            cart: {
                facturar_todo: true,
                d_fiscal: null,
                tramites: [],
                d_factura: null
            },

            contactsDataForAll: {
                fiscalContact: null,
                fiscalContactInvoice: null
            },

            contactsData: {
                fiscalContacts: [],
                fiscalContactInvoices: []
            },

            //Id del tramite que se le va asignar el dato de Contacto Fiscal
            procedureToAssignContact: 0,
            procedureContactDefault: {
                nombre: '', apellido_pat: '', apellido_mat: ''
            },

            showFiscalContactModal: false,
            selectingContactFor: 'receipt', // 'receipt' or 'invoice'

            requireInvoice: [],
            sameContactForInvoice: [],
            pantone: '#B08C55',
            pantoneBlack: '#15212F',
        }
    },

    watch: {
        cart(){
            this.setCartFinalData(this.cart)
        }
    },

    mounted() {
        this.resetCartForAll()
    },

    updated() {
        if (this.cart2DataDetails != null && !this.cart.facturar_todo){
            this.addProceduresToCart()
        }
    },

    methods: {

        //Verifica si uno varios de los tramites son facturables
        canInvoiceForAll(){
            let canInvoice = false

            this.procedures.forEach(procedure => {
                if (procedure.facturable == 1){
                    canInvoice = true
                    return true
                }
            })

            return canInvoice;
        },

        selectFiscalContact(type, procedure = null){
            this.selectingContactFor = type
            this.showFiscalContactModal = true

            this.procedureToAssignContact = procedure != null ? procedure.id : 0
            if (procedure === null){
                procedure = this.procedures[0]
            }

            // console.log(JSON.stringify(procedure))

            this.procedureContactDefault.nombre = procedure.nombre
            this.procedureContactDefault.apellido_pat = procedure.apellido_pat
            this.procedureContactDefault.apellido_mat = procedure.apellido_mat
        },

        onSelectedFiscalContact(fiscalContact){
            this.showFiscalContactModal = false

            if (this.procedureToAssignContact === 0){
                if (this.selectingContactFor === 'receipt'){
                    this.contactsDataForAll.fiscalContact = fiscalContact
                    this.cart.d_fiscal = fiscalContact.id
                }else{
                    if (fiscalContact.rfc != null && fiscalContact.rfc.length > 10){
                        this.contactsDataForAll.fiscalContactInvoice = fiscalContact
                        this.cart.d_factura = fiscalContact.id
                    }else{
                        this.errorCodeModal = 1
                        this.showErrorModal = true
                    }
                }
            }else{
                if (this.selectingContactFor === 'receipt'){
                    this.contactsData.fiscalContacts[this.procedureToAssignContact] =
                        fiscalContact
                    this.cart.d_fiscal[''+this.procedureToAssignContact] = fiscalContact.id

                }else {
                    if (fiscalContact.rfc != null && fiscalContact.rfc.length > 10){
                        this.contactsData.fiscalContactInvoices[this.procedureToAssignContact] = fiscalContact
                        this.cart.d_factura[''+this.procedureToAssignContact] = fiscalContact.id
                    }else {
                        this.errorCodeModal = 1
                        this.showErrorModal = true
                    }
                }
            }
        },

        setReceiptInfoForInvoiceAll(){
            if (this.sameContactForInvoiceForAll){
                if (this.contactsDataForAll.fiscalContact.rfc!=null &&
                    this.contactsDataForAll.fiscalContact.rfc.length > 10) {

                    this.contactsDataForAll.fiscalContactInvoice = this.contactsDataForAll.fiscalContact
                    this.cart.d_factura = this.contactsDataForAll.fiscalContactInvoice.id

                }
                else {
                    this.sameContactForInvoiceForAll = false
                    this.errorCodeModal = 0
                    this.showErrorModal = true
                }

            }else{
                this.contactsDataForAll.fiscalContactInvoice = null
                this.cart.d_factura = null
            }
        },

        setReceiptInfoForInvoice(procedureId){
            if (this.sameContactForInvoice[procedureId]){
                let fiscalContact = this.contactsData.fiscalContacts[procedureId]

                if (fiscalContact.rfc != null && fiscalContact.rfc.length > 10){
                    this.contactsData.fiscalContactInvoices[procedureId] = fiscalContact
                    this.cart.d_factura[procedureId] = fiscalContact.id
                }
                else{
                    this.sameContactForInvoice[procedureId] = false
                    this.errorCodeModal = 0
                    this.showErrorModal = true
                }
            }else {
                this.contactsData.fiscalContactInvoices[procedureId] = null
                this.cart.d_factura[procedureId] = null
            }
        },


        uniqueReceiptCheckChange(){
            if (!this.cart.facturar_todo){
                this.showCart2Details()

                this.resetCartForSeparateItems();
            }else {
                this.resetCartForAll()
            }
        },

        closeFiscalContactModal(){
            this.showFiscalContactModal = false
        },

        closeErrorModal(){
            this.showErrorModal = false
        },

        resetCartForAll(){
            this.cart = {
                facturar_todo: true,
                d_fiscal: null,
                tramites: [],
                d_factura: null
            }

            this.procedures.forEach(procedure => {
                this.cart.tramites.push(procedure.id)
            })

            if (this.defaultFiscalContact != null){
                this.contactsDataForAll.fiscalContact = this.defaultFiscalContact
                this.cart.d_fiscal = this.defaultFiscalContact.id
            }
        },

        resetCartForSeparateItems(){
            this.cart = {
                //facturar_todo: false,
                d_fiscal: {},
                tramites: [],
                d_factura: {}
            }
        },

        addProceduresToCart(){
            this.cart.tramites = []
            this.cart2DataDetails.tramites_carrito.forEach(procedure => {
                this.cart.tramites.push(procedure.id)
            })
        }
    }
}
</script>

<style scoped>
.cart2 .v-messages {display: none}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}

.v-sheet.v-card:not(.v-sheet--outlined){
    box-shadow: none !important;
}

.text-family{
    font-family: 'PoppinsRegular' !important;
}
.text-family-bold{
    font-family: 'PoppinsBold' !important;
}

.v-input--selection-controls__ripple .primary--text{
    color: #ff8400 !important;
}
</style>